// extracted by mini-css-extract-plugin
module.exports = {"title-slot-horizontal":"StandardTitleSlot-PLP-2846_title-slot-horizontal__n9W30"};